import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs5-placeholder-list2',
  templateUrl: './bs5-placeholder-list.component.html',
  styleUrls: ['./bs5-placeholder-list.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class Bs5PlaceholderList2Component {

  @Input()
  filterRowCnt: number = 1;

  counter(i: number) {
    return new Array(i);
  }

}
